import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const PersonalSettingsBypassPage = () => {
  const navigate = useNavigate()

  useEffect(() => {
    navigate('/settings/personal-settings/your-profile')
  }, [])
  return (
    <>
    </>
  )
}